import React from "react";
import classes from "./Card.module.css";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";

const Card = ({ dataItem, closeDrawer, main_category_id, sub_category_id }) => {
  const navigate = useNavigate();
  // const { ref, isVisible } = useInView();

  return (
    <div className={classes.main_card}
      onClick={() => {
        if (dataItem?.type === "game") {
          navigate(`/game/${dataItem?.name}?game=${dataItem?.id}`)
        } else {
          // navigate(`/watch/${dataItem?.name}?main_category_id=${main_category_id}&sub_category_id=${sub_category_id}&episode=${dataItem?.id}`)
          navigate(`/category/video/play`, {
            state: {
              video: dataItem
            }
          })
        }
      }}
    >
      <div className={classes.main_card_image}>
        {dataItem?.type === "game" ? (
          <img
            src={dataItem?.game_banner}
            alt={dataItem?.name}
            loading="lazy"
            className={classes.main_card_img}
          />
        ) : (
          <img
            src={dataItem?.video_thumbnail}
            alt={dataItem?.name}
            loading="lazy"
            className={classes.main_card_img}
          />
        )}
      </div>
      <p className={classes.episode_number}>{dataItem?.name}</p>
    </div>
  );
};

export default Card;
